import { motion } from "framer-motion";

const STEPS = [
  { n: "01", title: "Schedule a free 15-minute consultation", body: "Pick a time that works. No fees. No commitment." },
  { n: "02", title: "We review your situation", body: "We listen carefully and walk through possible opportunities together." },
  { n: "03", title: "Secure digital agreement", body: "If you want to move forward, you'll receive a clear, friendly digital contract." },
  { n: "04", title: "We guide you step-by-step", body: "We help organize records, identify qualifying conditions, and maximize your claim." },
];

export default function Process() {
  return (
    <section id="process" className="section">
      <div className="max-w-6xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
          transition={{ duration: 0.6 }} className="max-w-3xl"
        >
          <p className="text-[11px] tracking-[0.22em] uppercase text-slate-500">Our process</p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#0A1930] mt-3 leading-[1.05]">
            Simple, transparent, mission-driven.
          </h2>
        </motion.div>

        <div className="mt-14 relative">
          <div className="hidden md:block absolute left-0 right-0 top-12 h-px bg-gradient-to-r from-transparent via-slate-200 to-transparent" />
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {STEPS.map((s, i) => (
              <motion.div
                key={s.n}
                initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.55, delay: i * 0.08 }}
                className="relative"
                data-testid={`process-step-${i + 1}`}
              >
                <div className="w-12 h-12 rounded-full bg-white border border-slate-200 grid place-items-center text-[#0A1930] font-display text-sm tracking-wider shadow-sm">
                  {s.n}
                </div>
                <h3 className="font-display text-lg mt-5 text-[#0A1930] leading-snug">{s.title}</h3>
                <p className="mt-2 text-[15px] text-slate-600 leading-relaxed">{s.body}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
